import React, { Component } from 'react';
import { connect } from 'react-redux';
import { submit } from 'redux-form';
import PatientForm from '../../../components/authorised/patient/account/PatientForm'
import { patientCreate, patientUpdate } from '../../../redux/actions/patient/patientActions';
import {passwordUpdate} from '../../../itrust_common/redux/actions/passwordActions';
import SaveButton from '../../../itrust_common/components/others/SaveButton'
import ScrollToTarget from '../../../itrust_common/components/others/ScrollToTarget';
import _ from 'lodash';

class AccountInformation extends Component {
  constructor(props){
    super(props)
    this.state = {
      activeTab: 'personal-info',
      currentForm: 'patientForm'
    }
  }

  handlePatientSubmit(data) {
    const { isWizard, setWizardTab } = this.props
    if (isWizard) {
      this.props.dispatch(patientUpdate(data, { include: "*" })).then(() => {
        setWizardTab(2)
      })
    }
    else {
      if (data.id)
        this.props.dispatch(patientUpdate(data, { include: "*" }))
      else
        this.props.dispatch(patientCreate(data, { include: "*" }))
    }
    //Case when its created from appointment
  }

  handlePasswordSubmit(data) {
    data = {...data, patient_id: this.props.patientId}
    this.props.dispatch(passwordUpdate(data))
  }
  
  handleRemoteSubmit(){
    var currentForm = this.state.currentForm
    this.props.dispatch(submit(currentForm))
  }

  handleTabs(tab, form){
    var currentForm = this.state.currentForm
    if(tab=="password"){
      this.handleRemoteSubmit()
    }
    setTimeout(function(){
      this.setState({activeTab: tab, currentForm: form})
      ScrollToTarget(tab)
    }.bind(this), 500)
  }

  isTabActive(tab){
    if(this.state.activeTab === tab)
      return 'text-primary'
    else
      return 'text-muted';
  }

  render() {
    const { saving, patient, isWizard, isFullMode, isQuickAction } = this.props;
    return (
      <div>
        <div className={`position-fixed ${isWizard ? 'patient-profile-nav' : isFullMode ? 'patient-form-sections-appointment' : 'patient-form-sections-profile'}`}>
          <ul className="list-unstyled border border-light shadow-sm bg-white">
            <li className="py-5 pl-7 pr-9 border-bottom border-light border-bottom-2">
              <a href="javascript:void(0)" className={this.isTabActive('patient-personal-tab')} onClick={this.handleTabs.bind(this, 'patient-personal-tab', 'patientForm')}> Personal Information </a>
            </li>
            <li className="py-5 pl-7 pr-9 border-bottom border-light border-bottom-2">
              <a href="javascript:void(0)" className={this.isTabActive('patient-address-tab')} onClick={this.handleTabs.bind(this, 'patient-address-tab', 'patientForm')}> Address </a>
            </li>
            <li className="py-5 pl-7 pr-9 border-bottom border-light border-bottom-2">
              <a href="javascript:void(0)" className={this.isTabActive('patient-primary-insurance-tab')} onClick={this.handleTabs.bind(this, 'patient-primary-insurance-tab', 'patientForm')}> Insurance Detail </a>
            </li>
            <li className="py-5 pl-7 pr-9 border-bottom border-light border-bottom-2">
              <a href="javascript:void(0)" className={this.isTabActive('patient-primary-physician-tab')} onClick={this.handleTabs.bind(this, 'patient-primary-physician-tab', 'patientForm')}> Primary Physician </a>
            </li>
            <li className="py-5 pl-7 pr-9 border-bottom border-light border-bottom-2">
              <a href="javascript:void(0)" className={this.isTabActive('patient-term-of-service-tab')} onClick={this.handleTabs.bind(this, 'patient-term-of-service-tab', 'patientForm')}> Terms of Service </a>
            </li>
          </ul>
          {!isWizard && <SaveButton saving={saving} label="Save changes" handleOnClick={this.handleRemoteSubmit.bind(this)}/>}
        </div>
        <div className="patient-from-fields">
          <div className="row">
            <div className={`${isQuickAction ? 'col-11' : 'col-8'}`}>
              <div className="row">
                <div className="col-12">
                  <div className={this.state.currentForm === 'passwordForm' && 'd-none'}>
                    {!_.isEmpty(patient) && <PatientForm onSubmit={this.handlePatientSubmit.bind(this)} isLongForm={true} />}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { patient,appointment } = state;
  return {
    patient: patient.patient,
    saving: patient.saving,
    isFullMode:appointment.handlerData?.isFullMode
  }
} 
export default connect(mapStateToProps)(AccountInformation);
